export default __webpack_public_path__ + "static/media/insta.18d3367a.svg";